//import HeroProductCarousel from '../hero-product-carousel';

import Variant from "../../Variant";
import { DeliveryTimeTier, pickDeliveryTimeLabel } from "../../utils/deliveryTimes";

class ProductVariants {
  public variants: Array<Variant> | null;

  public product: any;

  private parentScope: any;
  public scope: HTMLElement | null;
  public wishlistScope: any | null;

  public selectedVariantObject: Variant | undefined;
  public variantId: HTMLInputElement | null;
  public price: HTMLElement | null;
  public priceVatLabel: HTMLElement | null;
  public quantity: HTMLInputElement | null;
  public description: HTMLElement | null;
  public articleNumber: HTMLElement | null;
  public materials: NodeListOf<HTMLElement> | null;
  public includedProducts: HTMLElement | null;
  public volume: HTMLElement | null;
  public drainOverflow: HTMLElement | null;
  public weight: HTMLElement | null;
  public apronHeight: HTMLElement | null;
  public totalDimensions: HTMLElement | null;
  public deliveryTime: HTMLElement | null;
  private deliveryTimeSpinner = '';
  private deliveryTimes: DeliveryTimeTier[] | null = null;
  private deliveryTimeRequests = new Map<string, Promise<DeliveryTimeTier[] | null>>();
  public deliveryNote: HTMLElement | null;
  public variantSku: HTMLInputElement | null;

  public deliveryCountryInput: HTMLInputElement | null;
  public currentTaxRateInput: HTMLInputElement | null;
  public isShopAvailable: HTMLInputElement | null;
  public deliveryCountryCurrency: string;
  public currentTaxRate: string;

  public addToCartButton: HTMLButtonElement | null;
  public addToCartButtonText: string;

  public colorSelectors: NodeListOf<HTMLInputElement> | null;
  public drainTypeSelectors: NodeListOf<HTMLInputElement> | null;
  public finishSelectors: NodeListOf<HTMLInputElement> | null;
  public cabinetFinishSelectors: NodeListOf<HTMLInputElement> | null;
  public sinkFinishSelectors: NodeListOf<HTMLInputElement> | null;
  public ledSelectors: NodeListOf<HTMLInputElement> | null;
  public widthSelect: HTMLSelectElement | null;
  public widthSelectors: NodeListOf<HTMLElement> | null;
  public finishCombinationSelect: HTMLSelectElement | null;
  public finishCombinationSelectors: NodeListOf<HTMLElement> | null;
  public lengthSelect: HTMLSelectElement | null;
  public lengthSelectors: NodeListOf<HTMLElement> | null;
  public diameterSelect: HTMLSelectElement | null;
  public diameterSelectors: NodeListOf<HTMLSelectElement> | null;
  public totalDimensionsSelect: HTMLSelectElement | null;
  public totalDimensionsSelectors: NodeListOf<HTMLSelectElement> | null;
  public apronHeightSelect: HTMLSelectElement | null;
  public apronHeightSelectors: NodeListOf<HTMLSelectElement> | null;
  public projectionSelect: HTMLSelectElement | null;
  public projectionSelectors: NodeListOf<HTMLSelectElement> | null;
  public modelSelect: HTMLSelectElement | null;
  public withAccessories: HTMLSelectElement | null;
  public modelSelectors: NodeListOf<HTMLSelectElement> | null;

  public selectedColor: string | null;
  public selectedFinish: string | null;
  public selectedFinishCombination: string | null | undefined;
  public selectedCabinetFinish: string | null;
  public selectedSinkFinish: string | null;
  public selectedDrainType: string | null;
  public selectedLED: string | null;
  public selectedWidth: string | null | undefined;
  public selectedLength: string | null | undefined;
  public selectedDiameter: string | null | undefined;
  public selectedApronHeight: string | null | undefined;
  public selectedTotalDimensions: string | null | undefined;
  public selectedProjection: string | null | undefined;
  public selectedModel: string | null | undefined;
  public selectedQuantity: string | null;

  public addToWishlistLinks: NodeListOf<HTMLLinkElement> | null;
  public wishlistSelector: HTMLElement | null;
  public addToCartLink: HTMLElement | null;
  public requestLink: HTMLElement | null;
  public requestBtns: NodeListOf<HTMLElement> | null;

  public heroCarousel: any | null;
  public heroCarouselDefaultSlides: NodeListOf<HTMLElement>;

  public editorialSlider: HTMLElement;
  public editorialSliderImageWrapper: NodeListOf<HTMLElement>;
  public editorialSliderDefaultItems: NodeListOf<HTMLElement>;

  public modelViewer: any | null;
  public finishProductsInputs: NodeListOf<HTMLInputElement> | null;
  public coloredProductsInputs: NodeListOf<HTMLInputElement> | null;
  public coloredProductsInputsGroup: HTMLElement | null;
  public modelViewerColor: string | null | undefined;
  public modelViewerTexture: string | null | undefined;
  public modelViewerCameraOrbit: string | null | undefined;
  public modelViewerScale: string | null | undefined;
  public modelViewerOrientation: string | null | undefined;

  public selectedColoredProductsInputIndex: number = 0;

  public deliveryTimeContainer: HTMLElement | null;

  private variantsData: any; //tree->drain_type->projection->width->length->diameter->model->led->apronHeight->color->finish->finish_combination->sink_finish->cabinet_finish

  load() {
  }

  cache(selector: string | null) {
    this.scope = document.getElementById('js-product-single');

    if (this.wishlistScope && selector) {
      this.scope = document.getElementById(selector);
      // @ts-ignore
      this.variantId = { value: this.scope?.dataset.selectedVariant };
      this.selectedDrainType = this.scope?.dataset.selectedDrainType || '0';
      this.selectedProjection = this.scope?.dataset.selectedProjection || '0';
      this.selectedWidth = this.scope?.dataset.selectedWidth || '0';
      this.selectedLength = this.scope?.dataset.selectedLength || '0';
      this.selectedDiameter = this.scope?.dataset.selectedDiameter || '0';
      this.selectedApronHeight = this.scope?.dataset.selectedApronHeight || '0';
      this.selectedTotalDimensions = this.scope?.dataset.selectedTotalDimensions || '0';
      this.selectedModel = this.scope?.dataset.selectedModel || '0';
      this.selectedLED = this.scope?.dataset.selectedLed || '0';
      this.selectedColor = this.scope?.dataset.selectedColor || '0';
      this.selectedFinish = this.scope?.dataset.selectedFinish || '0';
      this.selectedFinishCombination = this.scope?.dataset.selectedFinishCombination || '0';
      this.selectedCabinetFinish = this.scope?.dataset.selectedCabinetFinish || '0';
      this.selectedSinkFinish = this.scope?.dataset.selectedSinkFinish || '0';
      this.selectedQuantity = this.scope?.dataset.quantity || null;
    }

    this.variantsData = JSON.parse((this.scope?.querySelector('.o-product-detail') as HTMLElement)?.dataset.variants || '{}');

    if (this.scope) {
      if (!this.wishlistScope) {
        this.variantId = this.scope.querySelector('.js-product-variant-id');
        const url = new URL(window.location as unknown as string);
        if (url.searchParams.has('variant') && url.searchParams.get('variant') != '' && this.variantId) {
          // @ts-ignore
          this.variantId.value = url.searchParams.get('variant');
          let variant = this.getSelectedVariant();
          if (variant) {
            this.selectedDrainType =variant.drain_type?.toString() || '0';
            this.selectedProjection = variant.projection?.toString() || '0';
            this.selectedWidth = variant.width?.toString() || '0';
            this.selectedLength = variant.length?.toString() || '0';
            this.selectedDiameter = variant.diameter?.toString() || '0';
            this.selectedApronHeight = variant.apron_height?.toString() || '0';
            this.selectedTotalDimensions = variant.total_dimensions?.toString() || '0';
            this.selectedModel = variant.model?.toString() || '0';
            this.selectedLED = variant.led?.toString() || '0';
            this.selectedColor = variant.color?.toString() || '0';
            this.selectedFinish = variant.finish?.toString() || '0';
            this.selectedFinishCombination = variant.finish_combination?.toString() || '0';
            this.selectedCabinetFinish = variant.cabinet_finish?.toString() || '0';
            this.selectedSinkFinish = variant.sink_finish?.toString() || '0';
          }
        }
      }

      this.price = this.scope.querySelector('.js-product-price');
      this.priceVatLabel = this.scope.querySelector('.o-product-detail__price__vat');
      this.description = this.scope.querySelector('.js-product-description');
      this.articleNumber = this.scope.querySelector('.js-product-article-number');
      this.weight = this.scope.querySelector('.js-product-weight');
      this.drainOverflow = this.scope.querySelector('.js-product-drain-overflow');
      this.volume = this.scope.querySelector('.js-product-volume');
      this.apronHeight = this.scope.querySelector('.js-product-apron-height');
      this.totalDimensions = this.scope.querySelector('.js-product-total-dimensions');
      this.materials = this.scope.querySelectorAll('.js-product-material');
      this.includedProducts = this.scope.querySelector('.js-product-included-products');
      this.deliveryTime = this.scope.querySelector('.js-product-delivery-time');
      // The template's spinner, put back whenever a variant's delivery time is loading.
      this.deliveryTimeSpinner = this.deliveryTime?.innerHTML ?? '';
      this.deliveryNote = this.scope.querySelector('.js-product-delivery-note');
      this.quantity = this.scope.querySelector('.js-product-quantity input');
      this.variantSku = this.scope.querySelector('.js-product-variant-sku');

      this.deliveryCountryInput = document.querySelector('.js-ld-label input[checked]');
      this.currentTaxRateInput = document.querySelector('.js-ls-delivery-country-form input[name="currentTaxRate"]');
      this.deliveryCountryCurrency = this.deliveryCountryInput?.dataset.currency || 'EUR';
      this.currentTaxRate = this.currentTaxRateInput?.value || '0';

      this.deliveryTimeContainer = this.scope.querySelector('.js-product-delivery-time__container');

      this.drainTypeSelectors = this.scope.querySelectorAll('.js-product-drain-types');
      this.projectionSelect = this.scope.querySelector('select[name="projection"]');
      this.projectionSelectors = this.scope.querySelectorAll('select[name="projection"]');
      this.widthSelect = this.scope.querySelector('select[name="width"]');
      this.widthSelectors = this.scope.querySelectorAll('select[name="width"]');
      this.lengthSelect = this.scope.querySelector('select[name="length"]');
      this.lengthSelectors = this.scope.querySelectorAll('select[name="length"]');
      this.diameterSelect = this.scope.querySelector('select[name="diameter"]');
      this.diameterSelectors = this.scope.querySelectorAll('select[name="diameter"]');
      this.totalDimensionsSelect = this.scope.querySelector('select[name="totalDimensions"]');
      this.totalDimensionsSelectors = this.scope.querySelectorAll('select[name="totalDimensions"]');
      this.apronHeightSelect = this.scope.querySelector('select[name="apronHeight"]');
      this.apronHeightSelectors = this.scope.querySelectorAll('select[name="apronHeight"]');
      this.modelSelect = this.scope.querySelector('select[name="model"]');
      this.modelSelectors = this.scope.querySelectorAll('select[name="model"]');
      this.withAccessories = this.scope.querySelector('input[name="with-accessories"]');
      this.ledSelectors = this.scope.querySelectorAll('.js-product-led');
      this.colorSelectors = this.scope.querySelectorAll('.js-product-color');
      this.finishSelectors = this.scope.querySelectorAll('.js-product-finish');
      this.finishCombinationSelect = this.scope.querySelector('select[name="finishCombination"]');
      this.finishCombinationSelectors = this.scope.querySelectorAll('select[name="finishCombination"]');
      this.cabinetFinishSelectors = this.scope.querySelectorAll('.js-product-cabinet-finish');
      this.sinkFinishSelectors = this.scope.querySelectorAll('.js-product-sink-finish');

      this.addToCartButton = this.scope.querySelector('.js-product-add-to-cart-btn span:not(.a-button__icon)');
      this.addToCartButtonText = this.addToCartButton ? this.addToCartButton.innerText : '';

      this.addToWishlistLinks = document.querySelectorAll('.js-add-to-wishlist');
      this.addToCartLink = this.scope.querySelector('.js-add-to-cart-link');
      this.requestLink = this.scope.querySelector('.js-request-link');
      this.requestBtns = this.scope.querySelectorAll('.js-product-request-btn');

      this.heroCarousel = document.querySelector('.js-hero-product-carousel');
      if (this.heroCarousel) {
        this.heroCarouselDefaultSlides = this.heroCarousel.querySelectorAll('[data-variant="default"]');
      }

      this.editorialSlider = document.querySelector('.o-editorial-image-slider .swiper-container.desktop') as HTMLElement;
      if (this.editorialSlider) {
        this.editorialSliderImageWrapper = this.editorialSlider.querySelectorAll('.o-editorial-image-slider__image-wrapper');
        this.editorialSliderDefaultItems = this.editorialSlider.querySelectorAll('.o-editorial-image-slider__image');
      }

      this.modelViewer = document.querySelector('.js-product-detail-model-viewer');
      this.coloredProductsInputs = document.querySelectorAll('.js-product-colored-products-color');
      this.coloredProductsInputsGroup = document.querySelector('.js-product-color-custom-color-groups');
    }

    if (this.wishlistScope) {
      this.drainTypeSelectors?.forEach((selector) => (selector.checked = selector.value == this.selectedDrainType ? true : false));
      this.ledSelectors?.forEach((selector) => (selector.checked = selector.value == this.selectedLED ? true : false));
      this.colorSelectors?.forEach((selector) => (selector.checked = selector.value == this.selectedColor ? true : false));
      this.finishSelectors?.forEach((selector) => (selector.checked = selector.value == this.selectedFinish ? true : false));
      this.cabinetFinishSelectors?.forEach((selector) => (selector.checked = selector.value == this.selectedCabinetFinish ? true : false));
      this.sinkFinishSelectors?.forEach((selector) => (selector.checked = selector.value == this.selectedSinkFinish ? true : false));

      if (this.finishCombinationSelect) {
        this.finishCombinationSelect.value = this.selectedFinishCombination || '';
        const selectedOption = this.finishCombinationSelect.nextElementSibling;
        if (selectedOption) {
          selectedOption.innerHTML = this.selectedFinishCombination || '';
        }
        this.finishCombinationSelectors?.forEach((selector) => (selector.innerHTML == this.selectedFinishCombination ? selector.classList.add('same-as-selected') : null));
      }
      if (this.widthSelect) {
        this.widthSelect.value = this.selectedWidth || '';
        const selectedOption = this.widthSelect.nextElementSibling;
        if (selectedOption) {
          selectedOption.innerHTML = this.selectedWidth || '';
        }
        this.widthSelectors?.forEach((selector) => (selector.innerHTML == this.selectedWidth ? selector.classList.add('same-as-selected') : null));
      }
      if (this.lengthSelect) {
        this.lengthSelect.value = this.selectedLength || '';
        const selectedOption = this.lengthSelect.nextElementSibling;
        if (selectedOption) {
          selectedOption.innerHTML = this.selectedLength || '';
        }
        this.lengthSelectors?.forEach((selector) => (selector.innerHTML == this.selectedLength ? selector.classList.add('same-as-selected') : null));
      }
      if (this.quantity) {
        this.quantity.value = this.selectedQuantity || '';
      }

      this.updateWishlistLink();
    }
  }

  updateState() {
    if (!this.wishlistScope) {
      this.selectedDrainType = this.product.selectedDrainType || '0';
      this.selectedProjection = this.product.selectedProjection || '0';
      this.selectedWidth = this.product.selectedWidth || '0';
      this.selectedLength = this.product.selectedLength || '0';
      this.selectedDiameter = this.product.selectedDiameter || '0';
      this.selectedApronHeight = this.product.selectedApronHeight || '0';
      this.selectedTotalDimensions = this.product.selectedTotalDimensions || '0';
      this.selectedModel = this.product.selectedModel || '0';
      this.selectedLED = this.product.selectedLED || '0';
      this.selectedColor = this.product.selectedColor || '0';
      this.selectedFinish = this.product.selectedFinish || '0';
      this.selectedFinishCombination = this.product.selectedFinishCombination || '0';
      this.selectedCabinetFinish = this.product.selectedCabinetFinish || '0';
      this.selectedSinkFinish = this.product.selectedSinkFinish || '0';
    }
  }

  bindings() {
    window.addEventListener('servd.dynamicloaded', (e) => {
      this.deliveryCountryInput = document.querySelector('.js-ld-label input[checked]');
      this.isShopAvailable = document.querySelector('.js-ls-delivery-country-form input[name="isShopAvailable"]');
      this.currentTaxRateInput = document.querySelector('.js-ls-delivery-country-form input[name="currentTaxRate"]');
      this.deliveryCountryCurrency = this.deliveryCountryInput?.dataset.currency || 'EUR';
      this.currentTaxRate = this.currentTaxRateInput?.value || '0';
      const selectedVariant = this.selectedVariantObject;
      let productDetailEl = this.scope?.querySelector('.o-product-detail') as HTMLElement;

      // A country the shop doesn't sell to only takes inquiries, so the delivery
      // time line goes, "Produkt nicht verfügbar" with it (WBHB-10776).
      if (this.isShopAvailable && this.isShopAvailable.value != '1') {
        productDetailEl.classList.add('not-purchasable');
        this.hideDeliveryTime();
      }

      if (selectedVariant && this.price) {
        this.price.innerText = `${selectedVariant[`price-${this.deliveryCountryCurrency.toLowerCase()}` as keyof Variant][`${this.currentTaxRate}`]?.currency} ${selectedVariant[`price-${this.deliveryCountryCurrency.toLowerCase()}` as keyof Variant][`${this.currentTaxRate}`]?.price}`;
      } else {
        if (this.price) {
          this.price.innerText = `${this.price?.dataset[`price${this.deliveryCountryCurrency.toLowerCase()}-${this.currentTaxRate.split('.')[this.currentTaxRate.split('.').length - 1]}`]}` || '';
        }
      }

      if (this.price && this.priceVatLabel && this.price.dataset.priceWithVatLabel && this.price.dataset.priceWithoutVatLabel) {
        this.priceVatLabel.innerText = (this.currentTaxRate == '0' || this.currentTaxRate == '0.00') ? this.price.dataset.priceWithoutVatLabel : this.price.dataset.priceWithVatLabel;
      }

      productDetailEl.classList.remove('loading');
    }, {once: true});

    if (this.coloredProductsInputs) {
      this.coloredProductsInputs.forEach((input, index) => {
        input.addEventListener('click', () => {
          this.selectedColoredProductsInputIndex = index;

          if (this.coloredProductsInputs?.[this.selectedColoredProductsInputIndex]?.dataset.skybox != "" && this.coloredProductsInputs?.[this.selectedColoredProductsInputIndex]?.dataset.environmentImage) {
            this.modelViewer.skyboxImage = this.coloredProductsInputs?.[this.selectedColoredProductsInputIndex]?.dataset.environmentImage;
          }
          else if (input?.dataset?.skybox != "" && input?.dataset?.environmentImage) {
            this.modelViewer.skyboxImage = input?.dataset?.environmentImage;
          }

          if (this.coloredProductsInputs?.[this.selectedColoredProductsInputIndex]?.dataset.environmentImage) {
            this.modelViewer.environmentImage = this.coloredProductsInputs?.[this.selectedColoredProductsInputIndex]?.dataset.environmentImage;
          }
          else if (input?.dataset?.environmentImage) {
            this.modelViewer.environmentImage = input?.dataset?.environmentImage;
          }

          if (this.coloredProductsInputs?.[this.selectedColoredProductsInputIndex]?.dataset.exposure) {
            this.modelViewer.exposure = Number(this.coloredProductsInputs?.[this.selectedColoredProductsInputIndex]?.dataset.exposure);
          }
          else if (input?.dataset?.exposure) {
            this.modelViewer.exposure = Number(input?.dataset?.exposure);
          }

          if (this.coloredProductsInputs?.[this.selectedColoredProductsInputIndex]?.dataset.shadowIntensity) {
            this.modelViewer.shadowIntensity = Number(this.coloredProductsInputs?.[this.selectedColoredProductsInputIndex]?.dataset.shadowIntensity);
          }
          else if (input?.dataset?.shadowIntensity) {
            this.modelViewer.shadowIntensity = Number(input?.dataset?.shadowIntensity);
          }

          if (this.coloredProductsInputs?.[this.selectedColoredProductsInputIndex]?.dataset.shadowSoftness) {
            this.modelViewer.shadowSoftness = Number(this.coloredProductsInputs?.[this.selectedColoredProductsInputIndex]?.dataset.shadowSoftness);
          }
          else if (input?.dataset?.shadowSoftness) {
            this.modelViewer.shadowSoftness = Number(input?.dataset?.shadowSoftness);
          }

          this.modelViewer?.model.materials.forEach((material: any) => {
            material.pbrMetallicRoughness.setBaseColorFactor(
              input?.dataset?.color
                ?.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b) => '#' + r + r + g + g + b + b)
                ?.substring(1).match(/.{2}/g)
                ?.map(x => parseInt(x, 16))
                ?.map(x => x / 255)
            );
          });
        });
      });

      this.modelViewer?.addEventListener('load', () => {
        if (this.modelViewerCameraOrbit) {
          this.modelViewer.cameraOrbit = this.modelViewerCameraOrbit;
        }
        this.modelViewer?.model.materials.forEach((material: any) => {
          material.pbrMetallicRoughness.setBaseColorFactor(
            (this.modelViewerColor ? this.modelViewerColor : this.modelViewer.dataset.color as string)
              ?.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b) => '#' + r + r + g + g + b + b)
              ?.substring(1).match(/.{2}/g)
              ?.map(x => parseInt(x, 16))
              ?.map(x => x / 255)
          );
        });

        this.modelViewerTexture = this.modelViewerTexture ?? this.modelViewer.dataset.texture;
        if (this.modelViewerTexture) {
          this.modelViewer?.model?.materials.forEach((material: any) => {
            if (material) {
              const createAndApplyTexture = async () => {
                let newTexture = await this.modelViewer.createTexture(this.modelViewerTexture);
                material['pbrMetallicRoughness']['baseColorTexture'].setTexture(newTexture);
              };
              createAndApplyTexture();
            }
          });
        }
      })
    }

    this.bindEventListener(this.drainTypeSelectors, 'drain_type');
    this.bindEventListener(this.ledSelectors, 'led');
    this.bindEventListener(this.colorSelectors, 'color');
    this.bindEventListener(this.finishSelectors, 'finish');
    this.bindEventListener(this.cabinetFinishSelectors, 'cabinet_finish');
    this.bindEventListener(this.sinkFinishSelectors, 'sink_finish');

    this.quantity?.addEventListener('change', (e: Event) => {
      if ((this.variantId && this.deliveryTime) || (this.variantId && this.wishlistScope)) {
        const { value } = this.variantId; // variant id
        const quantity = this.quantity?.value;

        this.selectedQuantity = quantity || '';
        this.updateWishlistLink(parseInt(value));

        this.renderDeliveryTime();
      }
    });
    this.finishCombinationSelectors?.forEach((selector) => selector.addEventListener('change', this.handleFinishCombinationSelectClick.bind(this)));
    this.widthSelectors?.forEach((selector) => selector.addEventListener('change', this.handleWidthSelectClick.bind(this)));
    this.lengthSelectors?.forEach((selector) => selector.addEventListener('change', this.handleLengthSelectClick.bind(this)));
    this.diameterSelectors?.forEach((selector) => selector.addEventListener('change', this.handleDiameterSelectClick.bind(this)));
    this.totalDimensionsSelectors?.forEach((selector) => selector.addEventListener('change', this.handleTotalDimensionsSelectClick.bind(this)));
    this.apronHeightSelectors?.forEach((selector) => selector.addEventListener('change', this.handleApronHeightSelectClick.bind(this)));
    this.modelSelectors?.forEach((selector) => selector.addEventListener('change', this.handleModelSelectClick.bind(this)));
    this.projectionSelectors?.forEach((selector) => selector.addEventListener('change', this.handleProjectionSelectClick.bind(this)));

    this.initialUpdate();
  }

  initialUpdate() {
    if (this.drainTypeSelectors) {
      this.drainTypeSelectors.forEach((drainTypeSelector) => {
        if (drainTypeSelector.value == this.selectedDrainType) {
          drainTypeSelector.click();
        }
      });
    }
    if (this.ledSelectors) {
      this.ledSelectors.forEach((ledSelctor) => {
        if (ledSelctor.value == this.selectedLED) {
          ledSelctor.click();
        }
      });
    }
    if (this.colorSelectors) {
      this.colorSelectors.forEach((colorSelector) => {
        if (colorSelector.value == this.selectedColor) {
          colorSelector.click();
        }
      });
    }
    if (this.finishSelectors) {
      this.finishSelectors.forEach((finishSelector) => {
        if (finishSelector.value == this.selectedFinish) {
          finishSelector.click();
        }
      });
    }
    if (this.cabinetFinishSelectors) {
      this.cabinetFinishSelectors.forEach((cabinetFinishSelector) => {
        if (cabinetFinishSelector.value == this.selectedCabinetFinish) {
          cabinetFinishSelector.click();
        }
      });
    }
    if (this.sinkFinishSelectors) {
      this.sinkFinishSelectors.forEach((sinkFinishSelector) => {
        if (sinkFinishSelector.value == this.selectedSinkFinish) {
          sinkFinishSelector.click();
        }
      });
    }
    if (this.finishCombinationSelect) {
      (this.finishCombinationSelect.querySelector(`[value="${this.selectedFinishCombination}"]`) as HTMLFormElement).selected = true;
    }
    if (this.widthSelect) {
      (this.widthSelect.querySelector(`[value="${this.selectedWidth}"]`) as HTMLFormElement).selected = true;
    }
    if (this.lengthSelect) {
      (this.lengthSelect.querySelector(`[value="${this.selectedLength}"]`) as HTMLFormElement).selected = true;
    }
    if (this.diameterSelect) {
      (this.diameterSelect.querySelector(`[value="${this.selectedDiameter}"]`) as HTMLFormElement).selected = true;
    }
    if (this.apronHeightSelect) {
      (this.apronHeightSelect.querySelector(`[value="${this.selectedApronHeight}"]`) as HTMLFormElement).selected = true;
    }
    if (this.totalDimensionsSelect) {
      (this.totalDimensionsSelect.querySelector(`[value="${this.selectedTotalDimensions}"]`) as HTMLFormElement).selected = true;
    }
    if (this.modelSelect) {
      (this.modelSelect.querySelector(`[value="${this.selectedModel}"]`) as HTMLFormElement).selected = true;
    }
    if (this.projectionSelect) {
      (this.projectionSelect.querySelector(`[value="${this.selectedProjection}"]`) as HTMLFormElement).selected = true;
    }

    this.updateView(true);
  }

  handleRadioClick(e: Event, property: string) {
    const input = e.target as HTMLInputElement | null;
    let changed = false;
    if (input && input.value) {
      switch (property) {
        case 'color':
          if (this.selectedColor == input.value) {
            break;
          }
          this.selectedColor = input.value;
          this.checkSelectedTreeOptions(property, this.selectedColor);
          const galleryCarousel = this.parentScope?.galleryCarousel.getInstance();
          galleryCarousel?.el.classList.remove('is-hidden');
          this.modelViewer?.classList.remove('active');

          if (input.classList.contains('js-product-color-custom-color')) {
            this.coloredProductsInputsGroup?.classList.add('active');
            if (this.addToWishlistLinks) {
              this.addToWishlistLinks.forEach((link) => {
                link.style.display = 'none';
              })
            }
            if (this.addToCartLink) {
              this.addToCartLink.style.display = 'none';
            }
            if (this.requestLink) {
              this.requestLink.removeAttribute('style');
            }
          } else {
            this.coloredProductsInputsGroup?.classList.remove('active');
            if (this.addToWishlistLinks) {
              this.addToWishlistLinks.forEach((link) => {
                link.removeAttribute('style');
              })
            }
            if (this.addToCartLink) {
              this.addToCartLink.removeAttribute('style');
            }
            if (this.requestLink) {
              this.requestLink.style.display = 'none';
            }
          }
          changed = true;
          break;

        case 'finish':
          if (this.selectedFinish == input.value) {
            break;
          }
          this.selectedFinish = input.value;
          this.checkSelectedTreeOptions(property, this.selectedFinish);
          changed = true;
          break;

        case 'cabinet_finish':
          if (this.selectedCabinetFinish == input.value) {
            break;
          }
          this.selectedCabinetFinish = input.value;
          this.checkSelectedTreeOptions(property, this.selectedCabinetFinish);
          changed = true;
          break;

        case 'sink_finish':
          if (this.selectedSinkFinish == input.value) {
            break;
          }
          this.selectedSinkFinish = input.value;
          this.checkSelectedTreeOptions(property, this.selectedSinkFinish);
          changed = true;
          break;

        case 'drain_type':
          if (this.selectedDrainType == input.value) {
            break;
          }
          this.selectedDrainType = input.value;
          this.checkSelectedTreeOptions(property, this.selectedDrainType);
          changed = true;
          break;

        case 'led':
          if (this.selectedLED == input.value) {
            break;
          }
          this.selectedLED = input.value;
          this.checkSelectedTreeOptions(property, this.selectedLED);
          changed = true;
          break;

        default:
          console.warn(`handleRadioClick: Type '${property}' not supported`);
      }

      //this.updateAvailableOptions(property, input.value);
      if (changed) {
        this.updateView();
      }
    }
  }

  /**
   * ☝️ This relates to NormalizeProductSingle:705, look for `$json['tree']`
   * It's building a tree structure. Order is important
   */
  checkSelectedTreeOptions(property: String, id: string) {
    switch (property) {
      case 'drain_type':
        if (this.selectedProjection) {
          if (Object.keys(this.variantsData.tree[Number(id)]).includes(this.selectedProjection)) {
            id = this.selectedProjection;
          } else {
            (this.projectionSelect?.querySelector(`[value="${Object.keys(this.variantsData.tree[Number(id)])[0]}"]`) as HTMLFormElement).selected = true;
            this.projectionSelect?.dispatchEvent(new Event('change'));
            break;
          }
        }

      case 'projection':
        if (this.selectedWidth) {
          if (Object.keys(this.variantsData.tree[Number(this.selectedDrainType)][Number(id)]).includes(this.selectedWidth)) {
            id = this.selectedWidth;
          } else {
            (this.widthSelect?.querySelector(`[value="${Object.keys(this.variantsData.tree[Number(this.selectedDrainType)][Number(id)])[0]}"]`) as HTMLFormElement).selected = true;
            this.widthSelect?.dispatchEvent(new Event('change'));
            break;
          }
        }

      case 'width':
        if (this.selectedLength) {
          if (Object.keys(this.variantsData.tree[Number(this.selectedDrainType)][Number(this.selectedProjection)][Number(id)]).includes(this.selectedLength)) {
            id = this.selectedLength;
          } else {
            (this.lengthSelect?.querySelector(`[value="${Object.keys(this.variantsData.tree[Number(this.selectedDrainType)][Number(this.selectedProjection)][Number(id)])[0]}"]`) as HTMLFormElement).selected = true;
            this.lengthSelect?.dispatchEvent(new Event('change'));
            break;
          }
        }

      case 'length':
        if (this.selectedDiameter) {
          if (Object.keys(this.variantsData.tree[Number(this.selectedDrainType)][Number(this.selectedProjection)][Number(this.selectedWidth)][Number(id)]).includes(this.selectedDiameter)) {
            id = this.selectedDiameter;
          } else {
            (this.diameterSelect?.querySelector(`[value="${Object.keys(this.variantsData.tree[Number(this.selectedDrainType)][Number(this.selectedProjection)][Number(this.selectedWidth)][Number(id)])[0]}"]`) as HTMLFormElement).selected = true;
            this.diameterSelect?.dispatchEvent(new Event('change'));
            break;
          }
        }

      case 'diameter':
        if (this.selectedTotalDimensions) {
          if (Object.keys(this.variantsData.tree[Number(this.selectedDrainType)][Number(this.selectedProjection)][Number(this.selectedWidth)][Number(this.selectedLength)][Number(id)]).includes(this.selectedTotalDimensions)) {
            id = this.selectedTotalDimensions;
          }
          else {
            (this.totalDimensionsSelect?.querySelector(`[value="${Object.keys(this.variantsData.tree[Number(this.selectedDrainType)][Number(this.selectedProjection)][Number(this.selectedWidth)][Number(this.selectedLength)][Number(id)])[0]}"]`) as HTMLFormElement).selected = true;
            this.totalDimensionsSelect?.dispatchEvent(new Event('change'));
            break;
          }
        }

      case 'totalDimensions':
        if (this.selectedModel) {
          if (Object.keys(this.variantsData.tree[Number(this.selectedDrainType)][Number(this.selectedProjection)][Number(this.selectedWidth)][Number(this.selectedLength)][Number(this.selectedDiameter)][String(id)]).includes(this.selectedModel)) {
            id = this.selectedModel;
          }
          else {
            (this.modelSelect?.querySelector(`[value="${Object.keys(this.variantsData.tree[Number(this.selectedDrainType)][Number(this.selectedProjection)][Number(this.selectedWidth)][Number(this.selectedLength)][Number(this.selectedDiameter)][String(id)])[0]}"]`) as HTMLFormElement).selected = true;
            this.modelSelect?.dispatchEvent(new Event('change'));
            break;
          }
        }

      case 'model':
        if (this.selectedLED) {
          if (Object.keys(this.variantsData.tree[Number(this.selectedDrainType)][Number(this.selectedProjection)][Number(this.selectedWidth)][Number(this.selectedLength)][Number(this.selectedDiameter)][this.selectedTotalDimensions ?? 0][String(id)]).includes(this.selectedLED)) {
            id = this.selectedLED;
          }
          else {
            (this.scope?.querySelector(`[value="${Object.keys(this.variantsData.tree[Number(this.selectedDrainType)][Number(this.selectedProjection)][Number(this.selectedWidth)][Number(this.selectedLength)][Number(this.selectedDiameter)][this.selectedTotalDimensions ?? 0][String(id)])[0]}"]`) as HTMLInputElement).disabled = false;
            (this.scope?.querySelector(`[value="${Object.keys(this.variantsData.tree[Number(this.selectedDrainType)][Number(this.selectedProjection)][Number(this.selectedWidth)][Number(this.selectedLength)][Number(this.selectedDiameter)][this.selectedTotalDimensions ?? 0][String(id)])[0]}"]`) as HTMLElement).click();
            break;
          }
        }

      case 'led':
        if (this.selectedApronHeight) {
          if (Object.keys(this.variantsData.tree[Number(this.selectedDrainType)][Number(this.selectedProjection)][Number(this.selectedWidth)][Number(this.selectedLength)][Number(this.selectedDiameter)][this.selectedTotalDimensions ?? 0][String(this.selectedModel)][Number(id)]).includes(this.selectedApronHeight)) {
            id = this.selectedApronHeight;
          }
          else {
            (this.scope?.querySelector(`[value="${Object.keys(this.variantsData.tree[Number(this.selectedDrainType)][Number(this.selectedProjection)][Number(this.selectedWidth)][Number(this.selectedLength)][Number(this.selectedDiameter)][this.selectedTotalDimensions ?? 0][String(this.selectedModel)][Number(id)])[0]}"]`) as HTMLInputElement).disabled = false;
            (this.scope?.querySelector(`[value="${Object.keys(this.variantsData.tree[Number(this.selectedDrainType)][Number(this.selectedProjection)][Number(this.selectedWidth)][Number(this.selectedLength)][Number(this.selectedDiameter)][this.selectedTotalDimensions ?? 0][String(this.selectedModel)][Number(id)])[0]}"]`) as HTMLElement).click();
            break;
          }
        }

      case 'apronHeight':
        if (this.selectedColor) {
          if (Object.keys(this.variantsData.tree[Number(this.selectedDrainType)][Number(this.selectedProjection)][Number(this.selectedWidth)][Number(this.selectedLength)][Number(this.selectedDiameter)][this.selectedTotalDimensions ?? 0][String(this.selectedModel)][Number(this.selectedLED)][Number(id)]).includes(this.selectedColor)) {
            id = this.selectedColor;
          }
          else {
            (this.scope?.querySelector(`[value="${Object.keys(this.variantsData.tree[Number(this.selectedDrainType)][Number(this.selectedProjection)][Number(this.selectedWidth)][Number(this.selectedLength)][Number(this.selectedDiameter)][this.selectedTotalDimensions ?? 0][String(this.selectedModel)][Number(this.selectedLED)][Number(id)])[0]}"]`) as HTMLInputElement).disabled = false;
            (this.scope?.querySelector(`[value="${Object.keys(this.variantsData.tree[Number(this.selectedDrainType)][Number(this.selectedProjection)][Number(this.selectedWidth)][Number(this.selectedLength)][Number(this.selectedDiameter)][this.selectedTotalDimensions ?? 0][String(this.selectedModel)][Number(this.selectedLED)][Number(id)])[0]}"]`) as HTMLElement).click();
            break;
          }
        }

      case 'color':
        if (this.selectedFinish) {
          if (Object.keys(this.variantsData.tree[Number(this.selectedDrainType)][Number(this.selectedProjection)][Number(this.selectedWidth)][Number(this.selectedLength)][Number(this.selectedDiameter)][this.selectedTotalDimensions ?? 0][String(this.selectedModel)][Number(this.selectedLED)][Number(this.selectedApronHeight)][Number(id)]).includes(this.selectedFinish)) {
            id = this.selectedFinish;
          }
          else {
            (this.scope?.querySelector(`[value="${Object.keys(this.variantsData.tree[Number(this.selectedDrainType)][Number(this.selectedProjection)][Number(this.selectedWidth)][Number(this.selectedLength)][Number(this.selectedDiameter)][this.selectedTotalDimensions ?? 0][String(this.selectedModel)][Number(this.selectedLED)][Number(this.selectedApronHeight)][Number(id)])[0]}"]`) as HTMLInputElement).disabled = false;
            (this.scope?.querySelector(`[value="${Object.keys(this.variantsData.tree[Number(this.selectedDrainType)][Number(this.selectedProjection)][Number(this.selectedWidth)][Number(this.selectedLength)][Number(this.selectedDiameter)][this.selectedTotalDimensions ?? 0][String(this.selectedModel)][Number(this.selectedLED)][Number(this.selectedApronHeight)][Number(id)])[0]}"]`) as HTMLElement).click();
            break;
          }
        }

      case 'finish':
        if (this.selectedFinishCombination) {
          if (Object.keys(this.variantsData.tree[Number(this.selectedDrainType)][Number(this.selectedProjection)][Number(this.selectedWidth)][Number(this.selectedLength)][Number(this.selectedDiameter)][this.selectedTotalDimensions ?? 0][String(this.selectedModel)][Number(this.selectedLED)][Number(this.selectedApronHeight)][Number(this.selectedColor)][Number(id)]).includes(this.selectedFinishCombination)) {
            id = this.selectedFinishCombination;
          }
          else {
            (this.finishCombinationSelect?.querySelector(`[value="${Object.keys(this.variantsData.tree[Number(this.selectedDrainType)][Number(this.selectedProjection)][Number(this.selectedWidth)][Number(this.selectedLength)][Number(this.selectedDiameter)][this.selectedTotalDimensions ?? 0][String(this.selectedModel)][Number(this.selectedLED)][Number(this.selectedApronHeight)][Number(this.selectedColor)][String(id)])[0]}"]`) as HTMLFormElement).selected = true;
            this.finishCombinationSelect?.dispatchEvent(new Event('change'));
            break;
          }
        }

      case 'finish_combination':
        if (this.selectedCabinetFinish) {
          const possibleCabinetFinishes = this.variantsData.tree[Number(this.selectedDrainType)][Number(this.selectedProjection)][Number(this.selectedWidth)][Number(this.selectedLength)][Number(this.selectedDiameter)][this.selectedTotalDimensions ?? 0][String(this.selectedModel)][Number(this.selectedLED)][Number(this.selectedApronHeight)][Number(this.selectedColor)][Number(this.selectedFinish)][Number(id)];
          if (Object.keys(possibleCabinetFinishes).includes(this.selectedCabinetFinish)) {
            id = this.selectedCabinetFinish;
          }
          else {
            const cabinetFinishInput = (this.scope?.querySelector(`[name="product_cabinet_finish"][value="${Object.keys(possibleCabinetFinishes)[0]}"]`) as HTMLInputElement);
            cabinetFinishInput.disabled = false;
            cabinetFinishInput.click();
            break;
          }
        }

      case 'cabinet_finish':
        if (this.selectedSinkFinish) {
          const possibleSinkFinishes = this.variantsData.tree[Number(this.selectedDrainType)][Number(this.selectedProjection)][Number(this.selectedWidth)][Number(this.selectedLength)][Number(this.selectedDiameter)][this.selectedTotalDimensions ?? 0][String(this.selectedModel)][Number(this.selectedLED)][Number(this.selectedApronHeight)][Number(this.selectedColor)][Number(this.selectedFinish)][Number(this.selectedFinishCombination)][Number(id)];
          if (Object.keys(possibleSinkFinishes).includes(this.selectedSinkFinish)) {
            id = this.selectedSinkFinish;
          } else {
            const sinkFinishInput = (this.scope?.querySelector(`[name="product_sink_finish"][value="${Object.keys(possibleSinkFinishes)[0]}"]`) as HTMLInputElement);
            sinkFinishInput.disabled = false;
            sinkFinishInput.click();
            break;
          }
        }

      default:
        id = this.variantsData.tree[Number(this.selectedDrainType)][Number(this.selectedProjection)][Number(this.selectedWidth)][Number(this.selectedLength)][Number(this.selectedDiameter)][this.selectedTotalDimensions ?? 0][String(this.selectedModel)][Number(this.selectedLED)][Number(this.selectedApronHeight)][Number(this.selectedColor)][Number(this.selectedFinish)][Number(this.selectedFinishCombination)][Number(this.selectedCabinetFinish)][Number(id)];

        if (this.variantId) {
          this.variantId.value = id;
        }
        if (this.variantSku) {
          this.variantSku.value = this.variantsData.variants[id]['sku'];
        }
        break;
    }
  }

  bindEventListener(objects: NodeList | null, dataType: string, eventType: string = 'click') {
    if (objects) {
      Object.values(objects).forEach((object: Node) => {
        object.addEventListener(eventType, (e: Event) => this.handleRadioClick(e, dataType));
      });
    }
  }

  handleFinishCombinationSelectClick() {
    this.selectedFinishCombination = this.finishCombinationSelect?.selectedOptions[0].value;
    if (this.selectedFinishCombination) this.checkSelectedTreeOptions('finish_combination', this.selectedFinishCombination);
    this.updateView();
  }

  handleWidthSelectClick() {
    this.selectedWidth = this.widthSelect?.selectedOptions[0].value;
    if (this.selectedWidth) this.checkSelectedTreeOptions('width', this.selectedWidth);
    this.updateView();
  }

  handleLengthSelectClick() {
    this.selectedLength = this.lengthSelect?.selectedOptions[0].value;
    if (this.selectedLength) this.checkSelectedTreeOptions('length', this.selectedLength);
    this.updateView();
  }

  handleDiameterSelectClick() {
    this.selectedDiameter = this.diameterSelect?.selectedOptions[0].value;
    if (this.selectedDiameter) this.checkSelectedTreeOptions('diameter', this.selectedDiameter);
    this.updateView();
  }

  handleApronHeightSelectClick() {
    this.selectedApronHeight = this.apronHeightSelect?.selectedOptions[0].value;
    if (this.selectedApronHeight) this.checkSelectedTreeOptions('apronHeight', this.selectedApronHeight);
    this.updateView();
  }

  handleTotalDimensionsSelectClick() {
    this.selectedTotalDimensions = this.totalDimensionsSelect?.selectedOptions[0].value;
    if (this.selectedTotalDimensions) this.checkSelectedTreeOptions('totalDimensions', this.selectedTotalDimensions);
    this.updateView();
  }

  handleModelSelectClick() {
    this.selectedModel = this.modelSelect?.selectedOptions[0].value;
    if (this.selectedModel) this.checkSelectedTreeOptions('model', this.selectedModel);
    this.updateView();
  }

  handleProjectionSelectClick() {
    this.selectedProjection = this.projectionSelect?.selectedOptions[0].value;
    if (this.selectedProjection) this.checkSelectedTreeOptions('projection', this.selectedProjection);
    this.updateView();
  }

  async updateWishlistLink(selectedVariant: number | null = null) {
    if (this.addToWishlistLinks) {
      const count: any = [];

      if (selectedVariant) {
        try {
          const res = await fetch(`/api/v1/wishlist/in-list/id/${selectedVariant}`);
          const jsonRes = await res.json()

          if (jsonRes.lists.length) {
            jsonRes.lists.forEach((list: any) => {
              count.push({'listId': list})
            })

            this.addToWishlistLinks.forEach((link) => {
              link.classList.add('is-active');
              link.dataset.action = 'remove';
              link.href = link.dataset.removeUrl || link.href;
              link.dataset.count = JSON.stringify(count);
            })
          } else {
            this.addToWishlistLinks.forEach((link) => {
              link.classList.remove('is-active');
              link.dataset.action = 'add';
              link.href = link.dataset.addUrl || link.href;
              link.dataset.count = JSON.stringify([]);
            })
          }
        } catch (e) {
          this.addToWishlistLinks.forEach((link) => {
            link.classList.remove('is-active');
          })
        }
      }

      const url = new URL(this.addToWishlistLinks[this.addToWishlistLinks.length - 1].href);

      url.searchParams.set('elementId', String(selectedVariant));
      url.searchParams.set('fields[plaintext_title_1]', this.selectedQuantity ? String(this.selectedQuantity) : '1');

      if (count.length) {
        url.searchParams.set('listId', String(count[0]?.listId));
      } else {
        url.searchParams.delete('listId');
      }

      this.addToWishlistLinks.forEach((link) => {
        link.href = String(url);
      })
    }
  }

  async updateView(initialCall: boolean = false) {
    if (initialCall) {
      const url = new URL(window.location as unknown as string);
      if (url.searchParams.has('variant') && url.searchParams.get('variant') != '' && this.variantId) {
        // @ts-ignore
        this.variantId.value = url.searchParams.get('variant');
      }
    }
    const selectedVariant = this.getSelectedVariant();
    let isSelectedVariantInStock = false;
    this.disableOptions();

    if(selectedVariant && !selectedVariant.purchasable) {
      (this.scope?.querySelector('.o-product-detail') as HTMLElement).classList.add('not-purchasable');
      if(!selectedVariant.showNotPurchasableText) {
        (this.scope?.querySelector('.o-product-detail') as HTMLElement).classList.add('not-purchasable--no-text');
      } else {
        (this.scope?.querySelector('.o-product-detail') as HTMLElement).classList.remove('not-purchasable--no-text');
      }
    } else {
      if (this.isShopAvailable && this.isShopAvailable.value == '1') {
        (this.scope?.querySelector('.o-product-detail') as HTMLElement).classList.remove('not-purchasable');
      }
    }

    if (selectedVariant) {
      isSelectedVariantInStock = selectedVariant.has_unlimited_stock || Number(selectedVariant.stock) > 0;
    }
    if (this.addToWishlistLinks && selectedVariant?.id) {
      this.addToWishlistLinks.forEach((link) => {
        link.classList.remove('is-disabled');
      })
      this.updateWishlistLink(selectedVariant.id);
    }

    if (selectedVariant && isSelectedVariantInStock) {
      let productDetailEl = this.scope?.querySelector('.o-product-detail') as HTMLElement;

      if (this.variantId) {
        const selectedVariantId = String(selectedVariant.id);
        this.variantId.value = selectedVariantId;

        // set the variant id in the url
        if (!this.wishlistScope) {
          this.setUrlQueryParam('variant', selectedVariantId);
        }
      }

      if (this.price && !productDetailEl.classList.contains('loading')) {
        this.price.innerText = `${selectedVariant[`price-${this.deliveryCountryCurrency.toLowerCase()}` as keyof Variant][`${this.currentTaxRate}`]?.currency} ${selectedVariant[`price-${this.deliveryCountryCurrency.toLowerCase()}` as keyof Variant][`${this.currentTaxRate}`]?.price}`;
      }

      if (this.description) {
        this.description.innerHTML = selectedVariant.description;
      }

      if (this.articleNumber) {
        this.articleNumber.innerText = selectedVariant.sku;
      }

      if (this.materials) {
        this.materials.forEach((material: HTMLElement) => {
          material.innerText = selectedVariant.material;
        });
      }

      if (this.selectedColor) {
        this.colorSelectors?.forEach((selector) => (selector.checked = selector.value == selectedVariant.color.toString() ? true : false));
      }

      if (this.selectedFinish) {
        this.finishSelectors?.forEach((selector) => (selector.checked = selector.value == selectedVariant.finish.toString() ? true : false));
      }

      if (this.selectedCabinetFinish) {
        this.cabinetFinishSelectors?.forEach((selector) => (selector.checked = selector.value == selectedVariant.cabinet_finish.toString() ? true : false));
      }

      if (this.selectedSinkFinish) {
        this.sinkFinishSelectors?.forEach((selector) => (selector.checked = selector.value == selectedVariant.sink_finish.toString() ? true : false));
      }

      if (this.includedProducts) {
        this.includedProducts.innerText = selectedVariant.included_products ?? this.includedProducts.dataset.includedProductsDefault;
      }

      // Accessories live on the variant, so the input carries an id only while the
      // selected variant has some. An empty value is what tells the cart handler to skip
      // the accessories popup.
      if (this.withAccessories) {
        this.withAccessories.value = selectedVariant.has_required_accessories ? String(selectedVariant.id) : '';
      }

      if (this.weight) {
        this.weight.innerText = String(selectedVariant.weight);
      }

      if (this.volume) {
        this.volume.innerText = selectedVariant.volume;
      }

      if (this.apronHeight) {
        this.apronHeight.innerText = selectedVariant.apron_height + ' mm';
      }

      if (this.totalDimensions) {
        this.totalDimensions.innerText = selectedVariant.total_dimensions + ' mm';
      }

      if (this.drainOverflow) {
        this.drainOverflow.innerText = selectedVariant.drain_overflow;
      }

      this.refreshDeliveryTime();

      if (this.selectedDrainType) {
        this.drainTypeSelectors?.forEach((selector) => (selector.checked = selector.value == selectedVariant.drain_type.toString() ? true : false));
      }

      if (this.selectedLED) {
        this.ledSelectors?.forEach((selector) => (selector.checked = selector.value == selectedVariant.led.toString() ? true : false));
      }

      if (this.apronHeightSelect) {
        this.apronHeightSelect.value = selectedVariant.apron_height.toString() || '';
        const selectedOption = this.apronHeightSelect.nextElementSibling;
        if (selectedOption) {
          selectedOption.innerHTML = selectedVariant.width.toString() || '';
        }
        this.apronHeightSelectors?.forEach((selector) => (selector.innerHTML == selectedVariant.apron_height.toString() ? selector.classList.add('same-as-selected') : null));
      }

      if (this.widthSelect) {
        this.widthSelect.value = selectedVariant.width.toString() || '';
        const selectedOption = this.widthSelect.nextElementSibling;
        if (selectedOption) {
          selectedOption.innerHTML = selectedVariant.width.toString() || '';
        }
        this.widthSelectors?.forEach((selector) => (selector.innerHTML == selectedVariant.width.toString() ? selector.classList.add('same-as-selected') : null));
      }

      if (this.lengthSelect) {
        this.lengthSelect.value = selectedVariant.length.toString() || '';
        const selectedOption = this.lengthSelect.nextElementSibling;
        if (selectedOption) {
          selectedOption.innerHTML = selectedVariant.length.toString() || '';
        }
        this.lengthSelectors?.forEach((selector) => (selector.innerHTML == selectedVariant.length.toString() ? selector.classList.add('same-as-selected') : null));
      }

      if (this.totalDimensionsSelect) {
        this.totalDimensionsSelect.value = selectedVariant.total_dimensions.toString() || '';
        const selectedOption = this.totalDimensionsSelect.nextElementSibling;
        if (selectedOption) {
          selectedOption.innerHTML = selectedVariant.total_dimensions.toString() || '';
        }
        this.totalDimensionsSelectors?.forEach((selector) => (selector.innerHTML == selectedVariant.total_dimensions.toString() ? selector.classList.add('same-as-selected') : null));
      }

      if (this.diameterSelect) {
        this.diameterSelect.value = selectedVariant.diameter.toString() || '';
        const selectedOption = this.diameterSelect.nextElementSibling;
        if (selectedOption) {
          selectedOption.innerHTML = selectedVariant.diameter.toString() || '';
        }
        this.diameterSelectors?.forEach((selector) => (selector.innerHTML == selectedVariant.diameter.toString() ? selector.classList.add('same-as-selected') : null));
      }

      if (this.addToCartButton) {
        this.addToCartButton.innerText = this.addToCartButtonText;
        this.addToCartButton.disabled = false;
        this.addToCartButton.classList.remove('is-disabled');
        const addToCartButtonParent = this.addToCartButton.parentElement;
        // @ts-ignore
        addToCartButtonParent.dataset.products = JSON.stringify([selectedVariant]);
      }

      if (this.requestBtns) {
        this.requestBtns.forEach( (requestBtn) => {
          if(requestBtn.dataset.products) {
            // const colorProducts = JSON.parse(requestBtn.dataset.products);
            // @ts-ignore
            // colorProducts[0].id = selectedVariant.id;
            requestBtn.dataset.products = JSON.stringify([selectedVariant]);
          }
        })
      }

      setTimeout(() => {
        this.updateGalleryCarousel(selectedVariant);

        if (this.heroCarousel) {
          this.updateHeroCarousel(selectedVariant);
        }

        if (this.editorialSlider) {
          this.updateEditorialSlider(selectedVariant);
        }
      }, initialCall ? 1000 : 0)

    } else {
      if (this.addToCartButton) {
        this.addToCartButton.innerText = 'Produkt nicht verfügbar';
        this.addToCartButton.disabled = true;
        this.addToCartButton.classList.add('is-disabled');
      }

      if (this.addToWishlistLinks) {
        this.addToWishlistLinks.forEach((link) => {
          link.classList.add('is-disabled');
        })
      }
    }
  }

  /**
   * Shows the delivery time of the selected variant, asking the shop's API for its
   * tiers the first time the variant is selected (WBHB-10563). The Assortment Hub
   * computes them, so they are not in the cached page. The spinner the template
   * renders stays until they arrive.
   */
  async refreshDeliveryTime() {
    const id = this.variantId?.value;

    if (!this.deliveryTime || !id) {
      return;
    }

    let request = this.deliveryTimeRequests.get(id);

    if (!request) {
      request = this.fetchDeliveryTimes(id);
      this.deliveryTimeRequests.set(id, request);
    }

    // A quantity change while this loads must not pick from the previous variant's tiers.
    this.deliveryTimes = null;
    this.deliveryTime.innerHTML = this.deliveryTimeSpinner;

    const tiers = await request;

    // The visitor may have picked another variant while this one was loading.
    if (this.variantId?.value !== id) {
      return;
    }

    if (tiers === null) {
      this.hideDeliveryTime();

      return;
    }

    this.deliveryTimes = tiers;
    this.renderDeliveryTime();
  }

  /**
   * Hides the delivery time and the line below it, for a delivery country the
   * shop doesn't sell to or the server can't tell the region of yet (WBHB-10776).
   */
  hideDeliveryTime() {
    if (this.deliveryTimeContainer) {
      this.deliveryTimeContainer.style.display = 'none';
      this.deliveryTimeContainer.nextElementSibling?.classList.add('d-none');
    }
  }

  /**
   * Picks the label for the quantity in the form from the tiers already loaded.
   */
  renderDeliveryTime() {
    if (!this.deliveryTime || !this.deliveryTimes) {
      return;
    }

    this.deliveryTime.innerText = pickDeliveryTimeLabel(this.deliveryTimes, Number(this.quantity?.value || 1))
      ?? this.deliveryTime.dataset.fallback
      ?? '';
  }

  /**
   * Shows the Assortment Hub's delivery note for today below the delivery time,
   * or hides it when no note covers today. The note is the same for every
   * variant, so whichever answer arrives last sets it.
   */
  renderDeliveryNote(note: string | null) {
    if (!this.deliveryNote) {
      return;
    }

    this.deliveryNote.innerText = note ?? '';
    this.deliveryNote.hidden = !note;
  }

  /**
   * The tiers of one variant to the cart's delivery region, which the server
   * picks (WBHB-10776), or none when the request fails, which shows the
   * fallback. A failed request is forgotten, so selecting the variant again
   * retries. Null when the server answers without tiers, which hides the
   * delivery time.
   */
  async fetchDeliveryTimes(variantId: string): Promise<DeliveryTimeTier[] | null> {
    try {
      const res = await fetch(`${document.body.dataset.apiBaseUrl ?? '/'}api/v1/products/${variantId}/delivery-time`, {
        headers: { Accept: 'application/json' },
      });

      if (!res.ok) {
        throw new Error(`Delivery time request answered ${res.status}`);
      }

      const data: { deliveryTimes?: DeliveryTimeTier[], deliveryNote?: string | null } = await res.json();

      this.renderDeliveryNote(data.deliveryNote ?? null);

      if (data.deliveryTimes?.length === 0) {
        return null;
      }

      return data.deliveryTimes ?? [];
    } catch (error) {
      console.error(error);
      this.deliveryTimeRequests.delete(variantId);

      return [];
    }
  }

  disableOptions() {
    const possibleWidth = this.scope?.querySelectorAll('select[name="width"] option');
    const possibleLength = this.scope?.querySelectorAll('select[name="length"] option');
    const possibleDiameter = this.scope?.querySelectorAll('select[name="diameter"] option');
    const possibleTotalDimensions = this.scope?.querySelectorAll('select[name="totalDimensions"] option');
    const possibleApronHeight = this.scope?.querySelectorAll('select[name="apronHeight"] option');
    const possibleModel = this.scope?.querySelectorAll('select[name="model"] option');
    const possibleProjection = this.scope?.querySelectorAll('select[name="projection"] option');
    const possibleColors = this.scope?.querySelectorAll('[name="product_color"]');
    const possibleFinishs = this.scope?.querySelectorAll('[name="product_finish"]');
    const possibleLED = this.scope?.querySelectorAll('[name="product_led"]');
    const possibleCabinetFinishes = this.scope?.querySelectorAll('[name="product_cabinet_finish"]');
    const possibleSinkFinishes = this.scope?.querySelectorAll('[name="product_sink_finish"]');
    const availableProjection =         Object.keys(this.variantsData.tree[Number(this.selectedDrainType)]);
    const availableWidth =              Object.keys(this.variantsData.tree[Number(this.selectedDrainType)][Number(this.selectedProjection)]);
    const availableLength =             Object.keys(this.variantsData.tree[Number(this.selectedDrainType)][Number(this.selectedProjection)][Number(this.selectedWidth)]);
    const availableDiameter =           Object.keys(this.variantsData.tree[Number(this.selectedDrainType)][Number(this.selectedProjection)][Number(this.selectedWidth)][Number(this.selectedLength)]);
    const availableTotalDimensions =    Object.keys(this.variantsData.tree[Number(this.selectedDrainType)][Number(this.selectedProjection)][Number(this.selectedWidth)][Number(this.selectedLength)][Number(this.selectedDiameter)]);
    const availableModel =              Object.keys(this.variantsData.tree[Number(this.selectedDrainType)][Number(this.selectedProjection)][Number(this.selectedWidth)][Number(this.selectedLength)][Number(this.selectedDiameter)][this.selectedTotalDimensions ?? 0]);
    const availableLED =                Object.keys(this.variantsData.tree[Number(this.selectedDrainType)][Number(this.selectedProjection)][Number(this.selectedWidth)][Number(this.selectedLength)][Number(this.selectedDiameter)][this.selectedTotalDimensions ?? 0][String(this.selectedModel)]);
    const availableApronHeight =        Object.keys(this.variantsData.tree[Number(this.selectedDrainType)][Number(this.selectedProjection)][Number(this.selectedWidth)][Number(this.selectedLength)][Number(this.selectedDiameter)][this.selectedTotalDimensions ?? 0][String(this.selectedModel)][Number(this.selectedLED)]);
    const availableColors =             Object.keys(this.variantsData.tree[Number(this.selectedDrainType)][Number(this.selectedProjection)][Number(this.selectedWidth)][Number(this.selectedLength)][Number(this.selectedDiameter)][this.selectedTotalDimensions ?? 0][String(this.selectedModel)][Number(this.selectedLED)][Number(this.selectedApronHeight)]);
    const availableFinishs =            Object.keys(this.variantsData.tree[Number(this.selectedDrainType)][Number(this.selectedProjection)][Number(this.selectedWidth)][Number(this.selectedLength)][Number(this.selectedDiameter)][this.selectedTotalDimensions ?? 0][String(this.selectedModel)][Number(this.selectedLED)][Number(this.selectedApronHeight)][Number(this.selectedColor)]);
    const availableCabinetFinishes =    Object.keys(this.variantsData.tree[Number(this.selectedDrainType)][Number(this.selectedProjection)][Number(this.selectedWidth)][Number(this.selectedLength)][Number(this.selectedDiameter)][this.selectedTotalDimensions ?? 0][String(this.selectedModel)][Number(this.selectedLED)][Number(this.selectedApronHeight)][Number(this.selectedColor)][Number(this.selectedFinish)][Number(this.selectedFinishCombination)]);
    const availableSinkFinishes =       Object.keys(this.variantsData.tree[Number(this.selectedDrainType)][Number(this.selectedProjection)][Number(this.selectedWidth)][Number(this.selectedLength)][Number(this.selectedDiameter)][this.selectedTotalDimensions ?? 0][String(this.selectedModel)][Number(this.selectedLED)][Number(this.selectedApronHeight)][Number(this.selectedColor)][Number(this.selectedFinish)][Number(this.selectedFinishCombination)][Number(this.selectedCabinetFinish)]);

    possibleWidth?.forEach((widths) => {
      if (availableWidth.includes((widths as HTMLInputElement).value)) {
        widths.classList.remove('is-disabled');
        (widths as HTMLInputElement).disabled = false;

      } else {
        widths.classList.add('is-disabled');
        (widths as HTMLInputElement).disabled = true;
      }
    });

    possibleLength?.forEach((lengths) => {
      if (availableLength.includes((lengths as HTMLInputElement).value)) {
        lengths.classList.remove('is-disabled');
        (lengths as HTMLInputElement).disabled = false;
      } else {
        lengths.classList.add('is-disabled');
        (lengths as HTMLInputElement).disabled = true;
      }
    });

    possibleDiameter?.forEach((diameter) => {
      if (availableDiameter.includes((diameter as HTMLInputElement).value)) {
        diameter.classList.remove('is-disabled');
        (diameter as HTMLInputElement).disabled = false;
      } else {
        diameter.classList.add('is-disabled');
        (diameter as HTMLInputElement).disabled = true;
      }
    });

    possibleTotalDimensions?.forEach((totalDimension) => {
      if (availableTotalDimensions.includes((totalDimension as HTMLInputElement).value)) {
        totalDimension.classList.remove('is-disabled');
        (totalDimension as HTMLInputElement).disabled = false;
      } else {
        totalDimension.classList.add('is-disabled');
        (totalDimension as HTMLInputElement).disabled = true;
      }
    });

    possibleModel?.forEach((model) => {
      if (availableModel.includes((model as HTMLInputElement).value)) {
        model.classList.remove('is-disabled');
        (model as HTMLInputElement).disabled = false;
      } else {
        model.classList.add('is-disabled');
        (model as HTMLInputElement).disabled = true;
      }
    });

    possibleProjection?.forEach((projection) => {
      if (availableProjection.includes((projection as HTMLInputElement).value)) {
        projection.classList.remove('is-disabled');
        (projection as HTMLInputElement).disabled = false;
      } else {
        projection.classList.add('is-disabled');
        (projection as HTMLInputElement).disabled = true;
      }
    });

    possibleLED?.forEach((led) => {
      if (availableLED.includes((led as HTMLInputElement).value)) {
        (led.nextSibling?.nextSibling as HTMLElement).classList.remove('is-disabled');
        (led as HTMLInputElement).disabled = false;
      } else {
        (led.nextSibling?.nextSibling as HTMLElement).classList.add('is-disabled');
        (led as HTMLInputElement).disabled = true;
      }
    });

    possibleApronHeight?.forEach((apronHeight) => {
      if (availableApronHeight.includes((apronHeight as HTMLInputElement).value)) {
        apronHeight.classList.remove('is-disabled');
        (apronHeight as HTMLInputElement).disabled = false;
      } else {
        apronHeight.classList.add('is-disabled');
        (apronHeight as HTMLInputElement).disabled = true;
      }
    });

    possibleColors?.forEach((color) => {
      if (availableColors.includes((color as HTMLInputElement).value)) {
        (color.nextSibling?.nextSibling as HTMLElement).classList.remove('is-disabled');
        (color as HTMLInputElement).disabled = false;
      } else {
        (color.nextSibling?.nextSibling as HTMLElement).classList.add('is-disabled');
        (color as HTMLInputElement).disabled = true;
      }
    });

    possibleFinishs?.forEach((finish) => {
      if (availableFinishs.includes((finish as HTMLInputElement).value)) {
        (finish.nextSibling?.nextSibling as HTMLElement).classList.remove('is-disabled');
        (finish as HTMLInputElement).disabled = false;
      } else {
        (finish.nextSibling?.nextSibling as HTMLElement).classList.add('is-disabled');
        (finish as HTMLInputElement).disabled = true;
      }
    });

    possibleSinkFinishes?.forEach((sinkFinish) => {
      if (availableSinkFinishes.includes((sinkFinish as HTMLInputElement).value)) {
        (sinkFinish.nextSibling?.nextSibling as HTMLElement).classList.remove('is-hidden');
        (sinkFinish as HTMLInputElement).disabled = false;
      } else {
        (sinkFinish.nextSibling?.nextSibling as HTMLElement).classList.add('is-hidden');
        (sinkFinish as HTMLInputElement).disabled = true;
      }
    });

    possibleCabinetFinishes?.forEach((cabinetFinish) => {
      if (availableCabinetFinishes.includes((cabinetFinish as HTMLInputElement).value)) {
        (cabinetFinish.nextSibling?.nextSibling as HTMLElement).classList.remove('is-hidden');
        (cabinetFinish as HTMLInputElement).disabled = false;
      } else {
        (cabinetFinish.nextSibling?.nextSibling as HTMLElement).classList.add('is-hidden');
        (cabinetFinish as HTMLInputElement).disabled = true;
      }
    });
  }

  updateGalleryCarousel(selectedVariant: Variant) {
    if (this.parentScope && this.parentScope.galleryCarousel) {
      const galleryCarousel = this.parentScope.galleryCarousel.getInstance();

      if (!galleryCarousel) return;

      if (this.parentScope.galleryCarousel.isInstant) {
        this.parentScope.galleryCarousel.switchToVariant(selectedVariant.id);
        return;
      }

      galleryCarousel.el.classList.add('is-hidden');

      setTimeout(() => {
        galleryCarousel.removeAllSlides();

        Object.values(selectedVariant.gallery).forEach((image: any) => {
          galleryCarousel.prependSlide(`
            <div class="swiper-slide">
              <img class="o-images-carousel__image" width="${image.width}" height="${image.height}" src="${image.url}" alt="${image.title}" draggable="false" />
            </div>
          `);
        });

        galleryCarousel.slideTo(1, 0);
      }, 16);

      setTimeout(() => {
        galleryCarousel.update();

        if (galleryCarousel.slides.length - 2 > 1) {
          galleryCarousel.el.classList.remove('swiper-no-swiping');
          // galleryCarousel.autoplay.start();
        } else {
          galleryCarousel.el.classList.add('swiper-no-swiping');
          galleryCarousel.autoplay.stop();
        }
        galleryCarousel.el.classList.remove('is-hidden');

        if (!selectedVariant.disable_model_viewer && this.modelViewer) {
          galleryCarousel.el.classList.add('is-hidden');
          this.modelViewer.classList.add('active');

          this.modelViewer.src = selectedVariant.model_viewer.asset ?? this.modelViewer.dataset.asset;
          this.modelViewer.skyboxImage = selectedVariant.model_viewer.skybox ? selectedVariant.model_viewer.environment_image : null;
          this.modelViewer.environmentImage = selectedVariant.model_viewer.environment_image;
          this.modelViewer.exposure = selectedVariant.model_viewer.exposure ? Number(selectedVariant.model_viewer.exposure) : this.modelViewer.dataset.exposure ? Number(this.modelViewer.dataset.exposure) : 1;
          this.modelViewer.shadowIntensity = selectedVariant.model_viewer.shadow_intensity ? Number(selectedVariant.model_viewer.shadow_intensity) : this.modelViewer.dataset.shadowIntensity ? Number(this.modelViewer.dataset.shadowIntensity) : 1;
          this.modelViewer.shadowSoftness = selectedVariant.model_viewer.shadow_softness ? Number(selectedVariant.model_viewer.shadow_softness) : this.modelViewer.dataset.shadowSoftness ? Number(this.modelViewer.dataset.shadowSoftness) : 1;
          this.modelViewer.cameraOrbit = selectedVariant.model_viewer.camera_orbit ?? this.modelViewer.dataset.cameraOrbit;
          this.modelViewerCameraOrbit = selectedVariant.model_viewer.camera_orbit ?? this.modelViewer.dataset.cameraOrbit;
          this.modelViewerTexture = selectedVariant.model_viewer.texture ?? this.modelViewer.dataset.texture;

          if (this.modelViewerTexture) {
            this.modelViewer?.model?.materials.forEach((material: any) => {
              if (material) {
                const createAndApplyTexture = async () => {
                  // material['pbrMetallicRoughness'].baseColorTexture.setTexture(null);
                  let newTexture = await this.modelViewer.createTexture(this.modelViewerTexture);
                  material['pbrMetallicRoughness']['baseColorTexture'].setTexture(newTexture);
                };
                createAndApplyTexture();
              }
            });
          }

          this.modelViewer?.model?.materials.forEach((material: any) => {
            material.pbrMetallicRoughness.setBaseColorFactor(
              ((selectedVariant.model_viewer.color ? selectedVariant.model_viewer.color : this.modelViewer.dataset.color) as string)
                ?.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b) => '#' + r + r + g + g + b + b)
                ?.substring(1).match(/.{2}/g)
                ?.map(x => parseInt(x, 16))
                ?.map(x => x / 255)
            );
          });
          this.modelViewerColor = selectedVariant.model_viewer.color;

          if (this.coloredProductsInputsGroup?.classList.contains('active')) {
            if (this.coloredProductsInputs?.[this.selectedColoredProductsInputIndex]?.dataset.skybox != "" && this.coloredProductsInputs?.[this.selectedColoredProductsInputIndex]?.dataset.environmentImage) {
              this.modelViewer.skyboxImage = this.coloredProductsInputs?.[this.selectedColoredProductsInputIndex]?.dataset.environmentImage;
            }
            if (this.coloredProductsInputs?.[this.selectedColoredProductsInputIndex]?.dataset.environmentImage) {
              this.modelViewer.environmentImage = this.coloredProductsInputs?.[this.selectedColoredProductsInputIndex]?.dataset.environmentImage;
            }
            if (this.coloredProductsInputs?.[this.selectedColoredProductsInputIndex]?.dataset.exposure) {
              this.modelViewer.exposure = Number(this.coloredProductsInputs?.[this.selectedColoredProductsInputIndex]?.dataset.exposure);
            }
            if (this.coloredProductsInputs?.[this.selectedColoredProductsInputIndex]?.dataset.shadowIntensity) {
              this.modelViewer.shadowIntensity = Number(this.coloredProductsInputs?.[this.selectedColoredProductsInputIndex]?.dataset.shadowIntensity);
            }
            if (this.coloredProductsInputs?.[this.selectedColoredProductsInputIndex]?.dataset.shadowSoftness) {
              this.modelViewer.shadowSoftness = Number(this.coloredProductsInputs?.[this.selectedColoredProductsInputIndex]?.dataset.shadowSoftness);
            }
            if (this.modelViewer?.model && this.modelViewer?.model.materials) {
              this.modelViewer?.model.materials.forEach((material: any) => {
                material.pbrMetallicRoughness.setBaseColorFactor(
                  this.coloredProductsInputs?.[this.selectedColoredProductsInputIndex]?.dataset.color
                    ?.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b) => '#' + r + r + g + g + b + b)
                    ?.substring(1).match(/.{2}/g)
                    ?.map(x => parseInt(x, 16))
                    ?.map(x => x / 255)
                );
              });
            }
            this.modelViewerColor = this.coloredProductsInputs?.[this.selectedColoredProductsInputIndex]?.dataset.color;
          }
        } else {
          galleryCarousel.el.classList.remove('is-hidden');
          this.modelViewer?.classList.remove('active');
        }
      }, 128);
    } else if (this.wishlistSelector && this.wishlistSelector.querySelector('.js-product-detail-images-carousel')) {
      const galleryCarousel = this.wishlistSelector?.querySelector('.js-product-detail-images-carousel') as any;
      const galleryCarouselSwiper = galleryCarousel.swiper;

      if (galleryCarouselSwiper) {
        galleryCarouselSwiper.el.classList.add('is-hidden');

        setTimeout(() => {
          galleryCarouselSwiper.removeAllSlides();
          Object.values(selectedVariant.gallery).forEach((image: any) => {
            galleryCarouselSwiper.prependSlide(`
              <div class="swiper-slide">
                <img class="o-images-carousel__image" width="${image.width}" height="${image.height}" src="${image.url}" alt="${image.title}" draggable="false" />
              </div>
            `);
          });

          galleryCarouselSwiper.slideTo(1, 0);
        }, 500);

        setTimeout(() => {
          galleryCarouselSwiper.update();

          if (galleryCarouselSwiper.slides.length - 2 > 1) {
            galleryCarouselSwiper.el.classList.remove('swiper-no-swiping');
            // galleryCarouselSwiper.autoplay.start();
          } else {
            galleryCarouselSwiper.el.classList.add('swiper-no-swiping');
            galleryCarouselSwiper.autoplay.stop();
          }
          galleryCarouselSwiper.el.classList.remove('is-hidden');
        }, 1000);
      } else {
        galleryCarousel.classList.add('is-hidden');

        setTimeout(() => {
          const image = galleryCarousel.querySelector('.o-images-carousel__image');

          image.src = selectedVariant.gallery[0].url;
          image.alt = selectedVariant.gallery[0].title;
          image.setAttribute('width', selectedVariant.gallery[0].width);
          image.setAttribute('height', selectedVariant.gallery[0].height);

          galleryCarousel.classList.remove('is-hidden');
        }, 1000);
      }
    }
  }

  updateHeroCarousel(selectedVariant: Variant) {
    if (this.heroCarousel) {
      const heroCarousel = this.heroCarousel.swiper;
      if (heroCarousel) {

        if (selectedVariant.product_hero_item && Object.keys(selectedVariant.product_hero_item).length > 0) {
          //heroCarousel.el.classList.add('is-hidden');
          heroCarousel.removeAllSlides();

          Object.values(selectedVariant.product_hero_item).forEach((item) => {
            if (item.video && item.video_mobile) {
              heroCarousel.appendSlide(`
                <div class="swiper-slide">
                  <video playsinline autoplay muted>
                    <source src="${ window.innerWidth <= 768 && item.video_mobile.url ? item.video_mobile.url : item.video.url }" type="video/mp4">
                  </video>
                </div>
              `);
            } else if (item.image && item.image_mobile) {
              heroCarousel.appendSlide(`
                <div class="swiper-slide">
                  <div class="full-bg-image d-none d-md-block" style="background-image: url(${item.image.url})"></div>
                  ${item.image_mobile ? '<div class="full-bg-image full-bg-image--mobile d-block d-md-none" style="background-image: url(' + item.image_mobile.url + ')"></div>' : ''}
                </div>
              `);
            } else {
              heroCarousel.removeAllSlides();
              this.heroCarouselDefaultSlides.forEach((slide) => {
                heroCarousel.appendSlide(slide);
              });
            }
          });
        } else if (!this.heroCarousel.querySelector('[data-variant="default"]')) {
          heroCarousel.removeAllSlides();
          this.heroCarouselDefaultSlides.forEach((slide) => {
            heroCarousel.appendSlide(slide);
          });
        }
        heroCarousel.update();
        if (heroCarousel.slides.length - 2 > 1) {
          heroCarousel.el.classList.remove('swiper-no-swiping');
          // heroCarousel.slideToLoop(0,0);
          // heroCarousel.autoplay.start();
        } else {
          heroCarousel.el.classList.add('swiper-no-swiping');
          heroCarousel.autoplay.stop();
        }
        heroCarousel.slideToLoop(0, 0);

        this.heroCarousel.classList.remove('hidden');
      }
    }
  }

  updateEditorialSlider(selectedVariant: Variant) {
    if (selectedVariant.editorial_slider_items && selectedVariant.editorial_slider_items.length > 0) {
      this.editorialSliderImageWrapper.forEach((wrapper, index) => {
        wrapper.classList.add('is-hidden');
        setTimeout(() => {
          wrapper.innerHTML = `<div class="o-editorial-image-slider__image" style="background-image: url(${selectedVariant.editorial_slider_items[index].url})"></div>`;
          wrapper.classList.remove('is-hidden');
        }, 500);
      })
    } else if (!this.editorialSlider.querySelector('[data-variant="default"]')) {
      this.editorialSliderImageWrapper.forEach((wrapper, index) => {
        wrapper.classList.add('is-hidden');
        setTimeout(() => {
          if (wrapper.lastChild) {
            wrapper.removeChild(wrapper.lastChild);
          }
          wrapper.appendChild(this.editorialSliderDefaultItems[index]);
          wrapper.classList.remove('is-hidden');
        }, 500);
      })
    }
  }

  getSelectedVariant() {
    if (this.variantId) {
      const variant = this.variantsData.variants[this.variantId.value] as Variant | undefined;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: 'view_item',
        ecommerce: {
          currency: variant?.price.currency === '€' ? 'EUR' : (variant?.price.currency === 'CHF' ? 'CHF' : 'USD'),
          value: variant?.price.price.replace('.', '').replace(',', '.'),
          content_type: 'product',
          content_ids: [variant?.sku],
          items: [
            {
              item_id: variant?.sku,
            }
          ]
        }
      });

      this.selectedVariantObject = variant;
      return variant;
    }
    return undefined;
  }

  setUrlQueryParam(key: string, value: string) {
    // @ts-ignore
    if (history.replaceState && 'URLSearchParams' in window) {
      const { protocol, host, pathname, search } = window.location;

      const searchParams = new URLSearchParams(search);
      searchParams.set(key, value);

      const newUrl = `${protocol}//${host}${pathname}?${searchParams.toString()}`;

      window.history.replaceState({ path: newUrl }, '', newUrl);
    }
  }

  init(parentScope: any, wishlistScope: string | null = null, selector: string | null, wishlistSelector: HTMLElement | null = null) {
    this.parentScope = parentScope;

    // @ts-ignore
    this.product = window.product;

    if (wishlistScope) {
      this.wishlistScope = wishlistScope;
      // @ts-ignore
      this.product = { id: wishlistScope };
    }

    if (wishlistSelector) {
      this.wishlistSelector = wishlistSelector;
    }

    // @ts-ignore
    if (typeof this.product !== 'undefined' && this.product.id) {
      this.updateState();
      //this.load();
      this.cache(selector);
      this.bindings();

      const url = new URL(window.location as unknown as string);
      if (url.searchParams.get('variant') && this.variantId) {
        this.variantId.value = url.searchParams.get('variant') || this.variantId.value;

        /**
        * This is a temporary fix to prevent the double execution of updateView(true), for now only scoped
        * to merch type products and atelier category products.
        *
        * The double execution lead to a double init of the product gallery carousel which caused issues.
        *
        * Why temp? updateView() touches a lot of other parts of the page besides the gallery carousel, which
        * could break other things. This part needs refactoring and thorough testing of all kinds of
        * product detail pages.
        */

        const merchTypeProductIds = [9655997, 8234291, 8234293, 8234268, 8234271, 8234274, 8234285, 8234296, 8234313, 8234317, 8234237, 8234245, 8234249, 8234252, 8234259, 8234263, 8232240];
        const atelierCategoryProductIds = [9214097, 9204824, 9109725, 8889499, 8889501, 8889481, 8889460, 8889463, 8889440, 8889451, 8889453, 8889455, 8805352, 8234268, 8234271, 8234249];
        const isMerchTypeProduct = !Number.isNaN(parseInt(this.product.id)) && merchTypeProductIds.includes(parseInt(this.product.id));
        const isAtelierCategoryProduct = !Number.isNaN(parseInt(this.product.id)) && atelierCategoryProductIds.includes(parseInt(this.product.id));

        if (isMerchTypeProduct || isAtelierCategoryProduct) {
            console.log('Merch or atelier product detected - running new code branch');
            this.updateView();
        } else {
            console.log('Non-merch non-atelier product detected - running old code branch');
            this.updateView(true);
        }

        // End of temporary fix

      } else {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
          event: 'view_item',
          ecommerce: {
            currency: this.product?.currency,
            value: this.product?.price,
            content_type: 'product',
            content_ids: [this.product?.sku],
            items: [
              {
                item_id: this.product?.sku,
              }
            ]
          }
        });
      }

      if (this.wishlistScope && this.variantId) {
        this.updateView(true);
      }

      if (!this.wishlistScope) {
        this.disableOptions();
      }

      // A product without options never runs updateView(), so the first variant's
      // delivery time is asked for here as well. A second call reuses the request.
      this.refreshDeliveryTime();
    }
  }
}

export default ProductVariants;
